export const points = [
   {
      text: 'Составить полную картину передвижения денег с использованием офшорных зон',
   },
];

export const tasks = [
   {
      text: 'Выяснить для чего нужны офшорные зоны и чем они так привлекательны для предпринимателей и не только',
   },
   {
      text: 'Узнать сколько денег приходит в экономику России через офшоры',
   },
   {
      text: 'Показать связаны ли российские банки с офшорными зонами и каким образом, если связаны',
   },
   {
      text: 'Выяснить основные правовые риски содержания компании в офшоре',
   },
];
